import storageService from '../services/storage.js';
import couponService from '../services/coupon.js';

export default function singleMedicationChoice() {
  const singleProductBtn = document.querySelector('#landing-productbtn');

  listenForSingleProductBtn();

  function listenForSingleProductBtn() {
    singleProductBtn.addEventListener('click', (item) => {
      const id = singleProductBtn.dataset.testId;

      storageService().tests = [
        {
          name: singleProductBtn.dataset.name,
          price: singleProductBtn.dataset.price * 100,
          slug: singleProductBtn.dataset.slug,
          ...(id && { id: parseInt(id) }),
        },
      ];
      storageService().setUtiTreatmentType();
      couponService().applyDefaultCoupon();
      window.location.href = '/uti-pharmacy';
    });
  }
}
